module.exports = __webpack_public_path__ + "static/media/service-trophy-icon.760345ed.png";